import { createContext, useContext, useState } from "react";
import noop from "lodash/noop";
import { Container } from "./Container";

export interface BlockWithConnectorDataProviderProps {
  children: React.ReactNode;
  closeOnBlur?: boolean;
  defaultOpenId?: string | number;
  items: any[];
}

export interface BlockWithConnectorDataContext {
  activeItemId: string | number | undefined;
  items: any[];
  onCloseItemAndOpenNext: () => void;
  onToggleItem: (id: string | number) => void;
  setActiveItemId: (id: string | number | undefined) => void;
}

const BlockWithConnectorData = createContext<BlockWithConnectorDataContext>({
  items: [],
  activeItemId: undefined,
  setActiveItemId: noop,
  onToggleItem: noop,
  onCloseItemAndOpenNext: noop,
});
BlockWithConnectorData.displayName = "BlockWithConnectorData";

export const useBlockWithConnectorData = () =>
  useContext(BlockWithConnectorData);

export const BlockWithConnectorDataProvider = ({
  items = [],
  defaultOpenId,
  children,
  closeOnBlur = false,
}: BlockWithConnectorDataProviderProps) => {
  const [activeItemId, setActiveItemId] = useState(
    defaultOpenId || items[0]?.id,
  );

  const onToggleItem = (id: number | string) => {
    setActiveItemId(activeItemId === id ? undefined : id);
  };

  const onCloseItemAndOpenNext = () => {
    const nextActiveItem = getNextItemId();
    setActiveItemId(nextActiveItem);
  };

  const getNextItemId = () => {
    const index = items.findIndex(arrayItem => arrayItem.id === activeItemId);
    if (index !== -1) {
      return items[index + 1]?.id;
    }
  };

  return (
    <BlockWithConnectorData.Provider
      value={{
        items,
        activeItemId,
        setActiveItemId,
        onToggleItem,
        onCloseItemAndOpenNext,
      }}
    >
      <Container closeOnBlur={closeOnBlur}>{children}</Container>
    </BlockWithConnectorData.Provider>
  );
};
